export default __webpack_public_path__ + "5eccd9adf07cc6a286df4fd9fe9d7d22.png";